import DialogLink from "./DialogLink";

export default DialogLink;
